export default {
  /** 查询用户基本信息 */
  queryUserInfo: '/userInfo/queryUserInfo',

  /** 同步用户信息 */
  syncUserInfo: 'userInfo/syncUserInfo',

  /** 车型详情 */
  carDetail: 'order/getSpuDetailForPresale',

  /** 获取权益信息 */
  getCarRights: 'carSeries/getCarRights',

  /** 省份列表 */
  provinces: 'region/province',

  /** 城市列表 */
  cities: 'region/city',

  /** 区县列表 */
  district: 'region/district',

  /** 门店（体验中心）列表 */
  expCenter: 'home/expCenter/get-car-store',

  /** 发送短信验证码 */
  sendSmsCode: 'captcha/getSmsCode',

  /** 创建订单 */
  createOrder: 'order/createOrder',

  /** 修改订单 */
  modifyOrder: 'order/modifyUserCarBookingInfo',

  /** 订单列表 */
  orderList: 'order/queryOrderList',

  /** 订单详情 */
  orderDetail: 'order/queryOrderDetail',

  /** 取消订单 */
  orderCancel: 'order/cancelOrder',

  /** 申请退订 */
  applyRefund: 'order/applyRefund',

  /** 取消退订 */
  cancelRefund: 'order/cancelRefund',

  /** 预支付 */
  prePay: 'order/payOrder',

  /** 查询支付方式 */
  getPayChannels: 'pay/getPayMethodType',

  /** 发起支付 */
  pay: 'pay/pay',

  /** 支付回调 */
  clientPayFinished: 'pay/clientPayFinished',

  /** 认购须知 */
  bookingInformation: 'article/detail',

  /** 查询用户订单详情 */
  orderQueryOrderDetail: 'order/queryOrderDetail',

  /** 查询用户订单列表 */
  orderQueryOrderList: 'order/queryOrderList',

  /** 查询关联小订订单 */
  queryNotTurnBigOrderList: 'order/queryNotTurnBigOrderList',

  /** 大定电子签协议状态 */
  getContractStatus: 'goods/getContractStatus',

  /** 大定商品详情 */
  getSpuDetailForBigBooking: 'goods/getSpuDetailForBigBooking',
  /** 提交大定金融 */
  orderSubmitLoan: 'order/submitLoan',
  /** 用户取消订单 */
  orderCancelOrder: 'order/cancelOrder',

  /** 选装校验 */
  checkOptions: 'carSeries/getProducts',

  /** 查询用户服务订单列表 */
  serviceOrderList: 'service-order/list',

  /** 安装服务单详情 */
  installationDetail: 'evcharger/installation/detail',

  /** 删除服务单 */
  serviceOrderDelete: 'service-order/delete',
}
